import { render, staticRenderFns } from "./DictTree.vue?vue&type=template&id=f8b5d4c2&"
import script from "./DictTree.vue?vue&type=script&lang=js&"
export * from "./DictTree.vue?vue&type=script&lang=js&"
import style0 from "./DictTree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports